import { CommonModule } from '@angular/common';
import {Component, OnInit, Output, EventEmitter, Input} from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'kla-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss', '../../../app.component.scss'],
  standalone: true,
  imports: [ CommonModule, RouterModule ]
})
export class ButtonComponent implements OnInit {

  @Input()
  public title = 'Button';

  @Input()
  public url = '';

  @Input()
  public configLink:string = "";

  @Input()
  public target = '_self';

  @Input()
  public borderColor = '#3d3d3d';

  @Input()
  public backgroundColor = 'inherit';

  @Input()
  public color = 'black';

  @Input()
  public minWidth = '20px';

  @Input()
  public addPadding = '5px 30px 5px 26px';

  @Input()
  public textAlign = 'left';

  @Input()
  public class = '';

  @Input()
  public routerLink = '';

  @Output()
  public onClick: EventEmitter<Event> = new EventEmitter<Event>();

  public style: any;

  constructor() {
  }

  ngOnInit() {
    this.style = {
      'min-width': this.minWidth,
      'border-color': this.borderColor,
      'color': this.color,
      'background': this.backgroundColor,
      'text-align': this.textAlign
    };
  }

  clickOnButton(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.onClick.emit(event);
  }
}
